import { CONFIG } from 'config/config';

import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';

export const InnerWrapper = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	width: 90%;

	.title {
		margin-top: 40px;
	}
`;

export const DocumentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 20px 10px;
	background-color: ${CONFIG.colors.greyLight};
	width: 100%;
	border-radius: 10px;
	margin-top: 15px;
`;
export const DocumentWrapperText = styled.p`
	font-size: 18px;
	color: ${CONFIG.colors.grey};
	overflow-x: hidden;
	margin-right: 20px;
`;

export const DocumentWrapperButtons = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 10px;
`;
export const DocumentWrapperIconPDF = styled.img`
	width: 16px;
	height: auto;
	cursor: pointer;
`;
export const DocumentWrapperIconDownload = styled.img`
	width: 14px;
	height: auto;
	cursor: pointer;
`;
export const DocumentButton = styled.button`
	text-align: center;
	cursor: pointer;
	outline: none;

	transition: all 0.3s;

	color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primaryLighter;
		} else {
			return CONFIG.colors.primary;
		}
	}};
	background-color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primary;
		} else {
			return 'white';
		}
	}};
	font-size: 16px;
	padding: 10px 15px;
	border-radius: 10px;
	border: 1px solid ${CONFIG.colors.primary};
	margin: 0px 8px;
	margin-top: 15px;
	:focus {
		outline: none;
	}
`;
export const StepWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-top: 16px;
`;
export const StepWrapperItem = styled.div`
	display: flex;
	align-items: center;
	margin-top: 20px;
	justify-content: flex-start;
	margin-bottom: ${isMobile ? '15px' : '40px'};
`;
export const StepCircle = styled.div`
	height: 36px;
	width: 36px;
	background-color: ${CONFIG.colors.primary};
	border-radius: 50%;
	margin-right: 15px;
	font-size: ${isMobile ? '16px' : '17px'};
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
`;
